import { InhalerCompliance } from '@/jsonapi/CommonTypes'
import { GenericReading } from '@/jsonapi/SiteReadings'
import moment from 'moment-timezone'
import { GlucometerReadingCounts } from '@/jsonapi/SiteStats'

export function getErrorRateBarChartOptions(readings: GlucometerReadingCounts, rangeDesc: String) {
  let FIXED_COLOR = '#5791AD'
  let NOT_FIXED_COLOR = '#004461'

  if (!readings) return null
  const total = readings.totalCount

  let oidSwappedFixed = readings.fixedOidSwapCount
  let oidSwappedNotFixed = readings.notFixedOidSwapCount
  let oidSwappedTotal = readings.fixedOidSwapCount + readings.notFixedOidSwapCount

  let categories = ['Operator ID instead of PID']
  let arr = [
    {
      name: 'Fixed',
      type: 'bar',
      stack: 'stack',
      itemStyle: { color: FIXED_COLOR },
      label: {
        normal: {
          show: true,
          position: 'insideRight',
        },
      },
      data: [oidSwappedFixed],
    },
    {
      name: 'Not Fixed',
      type: 'bar',
      stack: 'stack',
      itemStyle: { color: NOT_FIXED_COLOR },
      label: {
        normal: {
          show: true,
          position: 'insideRight',
        },
      },
      data: [oidSwappedNotFixed],
    },
  ]

  return {
    title: {
      text: `Preventable Errors ${rangeDesc}`,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      data: [
        {
          name: 'Fixed',
          itemStyle: { color: FIXED_COLOR },
        },
        {
          name: 'Not Fixed',
          itemStyle: { color: NOT_FIXED_COLOR },
        },
      ],

      // ...
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      allowDecimals: false,
    },
    yAxis: {
      type: 'category',
      data: categories,
      allowDecimals: false,
    },
    series: arr,
  }
}
